import axios from './axiosConfig';

//http://localhost:8080/api/eventi/paese/search?term=IT
const getEventsFromASingleNation = async (term) => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/events.json' : process.env.REACT_APP_PAESE_SEARCH;
    const params = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? {} : { params: { term: term }};

    if(process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE') {
        let resp = {};
        let result = await getAllEvents();
        resp.data =  result.data.filter(elem => elem.nationISO === term);
        return resp;
    }

    return axios.get(URI, params); 
}

const getAllEvents = () => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/events.json' : process.env.REACT_APP_EVENTI;

    return axios.get(URI); 
}

const getAllManoscritti = () => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/manoscritti.json' : process.env.REACT_APP_MANOSCRITTI;

    return axios.get(URI); 
}

const getAllStampe = () => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/stampe.json' : process.env.REACT_APP_STAMPE;

    return axios.get(URI); 
}

const getAllImmagini = () => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/immagini.json' : process.env.REACT_APP_IMMAGINI;

    return axios.get(URI); 
}

const getManuscriptByEventId = (eventId) => {
    const URI = process.env.REACT_APP_LOCAL_API_TEST.toUpperCase() === 'TRUE' ? '/manoscrittiEvento.json' : process.env.REACT_APP_EVENTI + `${eventId}/manuscripts`;
    return axios.get(URI);
}


export default {
    getEventsFromASingleNation, 
    getAllEvents,
    getAllManoscritti,
    getAllStampe,
    getAllImmagini,
    getManuscriptByEventId
}

//  /api/eventi/paese/search  <---immetterlo per la chiamata